const home = [
  {
    path: '/homePage',
    name: 'homePage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/homePage'),
    meta: {
      name: '知产交易 · 全网商标专利交易查询',
      breadCrumbName: '商标专利交易中心'
    }
  },
];

export default home
